import Progress_ from "./Progress/Progress";

export const Progress = Progress_;